(function () {
  var root = document.querySelector('[data-rr-ask]');
  if (!root) return;
  var fab = root.querySelector('[data-rr-fab]');
  var openBtn = fab || root.querySelector('[data-rr-ask-open]');
  var lastTrigger = openBtn;
  function triggers() { return document.querySelectorAll('[data-rr-ask-open]'); }
  function setExpanded(v) { triggers().forEach(function (t) { t.setAttribute('aria-expanded', v); }); }
  var panel = root.querySelector('#rr-ask-panel');
  var closeBtn = root.querySelector('[data-rr-ask-close]');
  var form = root.querySelector('[data-rr-ask-form]') || root.querySelector('form');
  var body = root.querySelector('[data-rr-ask-body]');
  var done = root.querySelector('[data-rr-ask-done]');
  var again = root.querySelector('[data-rr-ask-again]');
  var errorEl = root.querySelector('[data-rr-ask-error]');
  var pageInput = root.querySelector('[data-rr-ask-page]');

  function open() {
    panel.hidden = false;
    root.classList.add('is-open');
    setExpanded('true');
    if (!done.hidden) { done.focus(); return; }
    var first = panel.querySelector('input:not([type=hidden]), textarea');
    (first || closeBtn).focus();
  }
  function close() {
    panel.hidden = true;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('rr-ask-open');
    setExpanded('false');
    var back = (lastTrigger && document.contains(lastTrigger) && lastTrigger.getClientRects().length) ? lastTrigger : openBtn;
    try { back.focus({ preventScroll: true }); } catch (err) { back.focus(); }
  }

  // Ask us must always stay visible, sitting above anything pinned to the bottom of the screen
  // (Shopify's preview/admin bar, a sticky buy bar, a cookie banner, any app bar). We measure
  // every visible bottom-pinned element under the button and lift the button above the tallest.
  var BAR_SEL = '#PBarNextFrameWrapper, #PBarNextFrame, #preview-bar-iframe, #admin-bar-iframe, iframe[src*="preview_bar"]';
  function isBottomBar(el) {
    if (el === root || root.contains(el) || el.contains(root)) return 0;
    if (el.closest && el.closest('[data-sticky-buy]')) return 0; // the sticky buy bar sits above the strip, never under it
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || +cs.opacity === 0) return 0;
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight;
    if (r.width < 1 || r.height < 1 || r.height > vh * 0.45) return 0;
    if (r.bottom < vh - 6 || r.top >= vh) return 0;
    var lr = launcherRect();
    if (r.right < lr.left || r.left > lr.right) return 0;
    return Math.ceil(vh - r.top) + 10;
  }
  function launcherRect() {
    var r = openBtn.getBoundingClientRect();
    return { left: r.left - 8, right: r.right + 8 };
  }
  function placeAboveBar() {
    var offset = 0;
    document.querySelectorAll(BAR_SEL).forEach(function (el) { offset = Math.max(offset, isBottomBar(el)); });
    // Generic scan: anything fixed or sticky hugging the bottom edge.
    var probes = [];
    var vw = window.innerWidth, vh = window.innerHeight;
    [vw - 24, vw - 70, vw - 130, vw - 180].forEach(function (x) { [2, 20, 50, 90].forEach(function (dy) { probes.push([Math.min(x, vw - 2), vh - dy]); }); });
    var seen = [];
    // No temporary style writes on the widget here: we just skip our own elements in the hit-test.
    probes.forEach(function (p) {
      var stack = document.elementsFromPoint ? document.elementsFromPoint(p[0], p[1]) : [];
      for (var i = 0; i < stack.length; i++) {
        var el = stack[i];
        if (root.contains(el)) continue;
        if (el === document.body || el === document.documentElement) break;
        for (var n = el; n && n !== document.body; n = n.parentElement) {
          if (seen.indexOf(n) !== -1) break;
          seen.push(n);
          var pos = window.getComputedStyle(n).position;
          if (pos === 'fixed' || pos === 'sticky') { offset = Math.max(offset, isBottomBar(n)); break; }
        }
      }
    });
    var v = offset + 'px';
    if (root.style.getPropertyValue('--rr-bar-offset') !== v) root.style.setProperty('--rr-bar-offset', v);
    // Mirror on <html> so the page's bottom clearance and the sticky buy bar follow the strip.
    var de = document.documentElement;
    if (de.style.getPropertyValue('--rr-bar-offset') !== v) de.style.setProperty('--rr-bar-offset', v);
  }
  // Placement. Where the page has a real side gutter (wide desktop), the launcher floats in the
  // bottom-left gutter, clear of the content column. Everywhere else it docks into the sticky
  // header beside Bag, so it stays visible on every scroll position without covering page content.
  var FLOAT_W = 112; // compact floating pill width incl. margin; refreshed when measured
  function setVar(name, v) { if (root.style.getPropertyValue(name) !== v) root.style.setProperty(name, v); }
  // Ask us lives in a bottom support strip (Ash, 23 Oct 05:37). It never docks in the header.
  function placeMode() {
    if (root.classList.contains('rr-ask--dock')) root.classList.remove('rr-ask--dock');
  }
  var barTick = null;
  function schedulePlace() { if (barTick) return; barTick = requestAnimationFrame(function () { barTick = null; placeMode(); placeAboveBar(); }); }
  placeMode();
  placeAboveBar();
  window.addEventListener('resize', schedulePlace);
  window.addEventListener('scroll', schedulePlace, { passive: true });
  // Ignore mutations inside the widget itself (including our own --rr-bar-offset write), so
  // measuring can never retrigger itself.
  function onMutations(list) {
    for (var i = 0; i < list.length; i++) { if (!root.contains(list[i].target)) { schedulePlace(); return; } }
  }
  try { new MutationObserver(onMutations).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden'] }); } catch (err) {}
  setInterval(schedulePlace, 1000);

  // Every Ask us trigger (floating face, price note, FAQ, strip, footer) is a real link to the
  // panel, so it still works without JavaScript; here it becomes a button that toggles the one panel.
  triggers().forEach(function (t) {
    if (t.tagName === 'A') t.setAttribute('role', 'button');
    t.setAttribute('aria-controls', 'rr-ask-panel');
    t.setAttribute('aria-haspopup', 'dialog');
    t.setAttribute('aria-expanded', 'false');
    t.addEventListener('click', function (e) {
      e.preventDefault();
      if (panel.hidden) { lastTrigger = t; open(); } else { close(); }
    });
    t.addEventListener('keydown', function (e) {
      if (t.tagName === 'A' && (e.key === ' ' || e.key === 'Spacebar')) { e.preventDefault(); t.click(); }
    });
  });
  if (fab) {
    // One short blink after the face first appears; never loops.
    setTimeout(function () { fab.classList.add('is-blink'); setTimeout(function () { fab.classList.remove('is-blink'); }, 260); }, 1100);
  }
  closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && !panel.hidden) { e.preventDefault(); close(); }
  });

  root.querySelectorAll('[data-rr-quick]').forEach(function (chip) {
    chip.addEventListener('click', function () {
      var target = document.getElementById(chip.getAttribute('aria-controls'));
      var show = chip.getAttribute('aria-expanded') !== 'true';
      root.querySelectorAll('[data-rr-quick]').forEach(function (c) {
        c.setAttribute('aria-expanded', 'false');
        var t = document.getElementById(c.getAttribute('aria-controls'));
        if (t) t.hidden = true;
      });
      if (show && target) { chip.setAttribute('aria-expanded', 'true'); target.hidden = false; }
    });
  });

  function showError(msg, field) {
    errorEl.textContent = msg;
    errorEl.hidden = false;
    if (field) { field.setAttribute('aria-invalid', 'true'); field.focus(); }
  }
  function clearErrors() {
    errorEl.hidden = true;
    errorEl.textContent = '';
    form.querySelectorAll('[aria-invalid]').forEach(function (f) { f.removeAttribute('aria-invalid'); });
  }
  // Only Shopify's returned Liquid state can acknowledge a native contact submission.
  (function ackReturn() {
    var posted = root.querySelector('[data-rr-ask-posted]');
    var serverError = root.querySelector('[data-rr-ask-server-error]');
    if (!posted && !serverError) return;
    var handed = false;
    try { handed = sessionStorage.getItem('rr-ask-handoff') === '1'; sessionStorage.removeItem('rr-ask-handoff'); } catch (err) {}
    var otherForm = Array.prototype.some.call(document.querySelectorAll('input[name="form_type"][value="contact"]'), function (i) { return !root.contains(i); });
    if (otherForm && !handed && !/rr-ask/.test(window.location.hash)) return;
    body.hidden = !serverError;
    done.hidden = !!serverError;
    panel.hidden = false;
    root.classList.add('is-open');
    setExpanded('true');
    var target = serverError || done;
    setTimeout(function () { try { target.focus({ preventScroll: true }); } catch (err) { target.focus(); } }, 50);
    if (posted && !serverError) {
      try {
        var params = new URLSearchParams(window.location.search);
        params.delete('contact_posted');
        var q = params.toString();
        history.replaceState(history.state, '', window.location.pathname + (q ? '?' + q : ''));
      } catch (err) {}
    }
  })();

  if (again) again.addEventListener('click', function () {
    form.reset();
    syncValidity();
    clearErrors();
    done.hidden = true;
    body.hidden = false;
    var first = form.querySelector('input:not([type=hidden])');
    if (first) first.focus();
  });

  // Native constraint validation runs before submit; Shopify owns CAPTCHA and the POST.
  // No fetch, programmatic submit, timeout retry or second submission path exists here.
  var nameField = form.querySelector('#rr-ask-name');
  var emailField = form.querySelector('#rr-ask-email');
  var questionField = form.querySelector('#rr-ask-question');
  var validatedFields = [nameField, emailField, questionField];
  function syncValidity() {
    nameField.setCustomValidity(nameField.value.trim() ? '' : 'Please add your name.');
    emailField.setCustomValidity(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailField.value.trim()) ? '' : 'Please add a valid email so we can reply.');
    questionField.setCustomValidity(questionField.value.trim() ? '' : 'Please add your question.');
  }
  validatedFields.forEach(function (field) {
    field.addEventListener('input', function () { clearErrors(); syncValidity(); });
  });
  syncValidity();
  form.addEventListener('invalid', function (e) {
    if (validatedFields.indexOf(e.target) === -1) return;
    e.preventDefault();
    var first = validatedFields.filter(function (field) { return !field.validity.valid; })[0];
    if (e.target === first) showError(first.validationMessage, first);
  }, true);
  form.addEventListener('submit', function () {
    clearErrors();
    if (pageInput) pageInput.value = window.location.pathname;
    try { sessionStorage.setItem('rr-ask-handoff', '1'); } catch (err) {}
    // Do not preventDefault or disable the submitter: Shopify's native CAPTCHA flow continues.
  });
})();

/* Keep the page-level dialog state in sync with the retained bottom support panel. */
(function () {
  var root = document.querySelector('[data-rr-ask]');
  if (!root) return;
  function sync() { document.documentElement.classList.toggle('rr-ask-open', root.classList.contains('is-open')); }
  sync();
  if (window.MutationObserver) new MutationObserver(sync).observe(root, { attributes: true, attributeFilter: ['class'] });
})();
